var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShieldPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.62964 0.13425C8.02378 -0.0447499 8.47622 -0.0447501 8.87036 0.13425L15.6204 3.20237C16.1558 3.44573 16.4999 3.98022 16.5 4.56833V6.67404L16.4934 7.05857C16.3582 11.0255 14.1382 14.6402 10.637 16.55L8.25 17.8523L5.86304 16.55C2.36178 14.6402 0.141815 11.0255 0.0065918 7.05857L0 6.67404V4.56833C9.45751e-05 4.01686 0.302391 3.51272 0.781494 3.25144L0.879639 3.20237L7.62964 0.13425Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 5.5V11.5M5.25 8.5H11.25",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShieldPlus);
export default __webpack_public_path__ + "static/media/shieldPlus.7048ce1f2237bf49811821c3ccc398fc.svg";
export { ForwardRef as ReactComponent };